import config from '../../config/config';

import postRequest from './base/post';
import postStream from './base/postStream';

export default {
  /**
   * Self register API
   * @param data
   */
  selfRegistration: (data: any, handleUploadProgress: (progress: any) => void): Promise<any> => {
    return postStream(
      `${config.accountApiUrl}api/facility/v1/user-account/create`,
      data,
      true,
      handleUploadProgress,
    );
  },
  /**
   * Login API
   * @param data
   */
  login: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/login`, data);
  },
  /**
   * Verify Email API
   * @param data
   */
  verifyEmail: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/verify-email`, data);
  },
  /**
   * Verify Email API
   * @param data
   */
  resendEmailOTP: (): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/resend-email-otp`);
  },
  /**
   * Verify Email API
   * @param data
   */
  resendMobileOTP: (): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/resend-sms-otp`);
  },
  /**
   * Verify Mobile API
   * @param data
   */
  verifyMobile: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/verify-mobile`, data);
  },
  /**
   * Forgot password API
   * @param data
   */
  forgotPassword: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/forgot-password`, data);
  },
  /**
   * Verify reset password OTP API
   * @param data
   */
  resetPasswordOTPVerify: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/forgot-password-otp-verify`, data);
  },
  /**
   * Reset password API
   * @param data
   */
  resetPassword: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/reset-password`, data);
  },
  /**
   * Reset password token API
   * @param data
   */
  resetPasswordToken: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/reset-password-token`, data);
  },
  /**
   * Reset password API
   * @param data
   */
  initialResetPassword: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/initial-reset-password`, data);
  },
  /**
   * Logout API
   * @param data
   */
  logout: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/facility/v1/auth/logout`, data);
  },
};
